export const MENSAGEM_ERRO_PADRAO = 'Ocorreu um erro inesperado. Tente novamente.';

// Extrai a mensagem de err?.response?.data?.errors[].message, com fallback.
export const extrairMensagemErro = (err, mensagemPadrao = MENSAGEM_ERRO_PADRAO) => {
    const errors = err?.response?.data?.errors || [];
    if (errors.length > 0) {
        return errors.map((item) => item.message).join(' ');
    }
    if (!err?.response && err?.message) {
        return err.message;
    }
    return mensagemPadrao;
};
